import { OptionsClass } from "@/domain/entities/MainApp";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from 'vue-i18n';
import { AccountController } from '@/app/ui/controllers/AccountController';


const i18nInstance = createI18n({
  legacy: false,
  locale: AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
  fallbackLocale: "id",
  globalInjection: false,
  messages: {
    en,
    id,
    my
  }
});
const translate = i18nInstance.global.t;
export const LOCATION_AREA: OptionsClass[] = [
  new OptionsClass({ name: "STI", value: "STI" }),
  new OptionsClass({ name: "BAGGING", value: "BAGGING" }),
  new OptionsClass({ name: "CARGO", value: "CARGO" }),
  new OptionsClass({ name: "STI-DEST", value: "STI-DEST" }),
  new OptionsClass({ name: "DEL", value: "DEL" }),
  new OptionsClass({ name: "DEX/CODREJ", value: "DEX/CODREJ" }),
  new OptionsClass({ name: "TRANSIT", value: "TRANSIT" }),
  new OptionsClass({
    name: translate("cariStt.scan.others"),
    value: "OTHERS"
  })
];
